import { clearPortalImpersonationCookies } from '@repo/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';
import {
  appendResponseHeader,
  getWebRequest,
} from '@tanstack/react-start/server';
import { deleteJWTToken } from '~/utils/jwt';

/**
 * Server function to handle logout
 * Clears all authentication cookies including:
 * - Regular JWT token
 * - Admin JWT token (if impersonating)
 * - Impersonation cookie (if impersonating)
 */
const logoutFn = createServerFn().handler(async () => {
  const request = getWebRequest();
  const responseHeaders = new Headers();
  const context = { request, responseHeaders };

  // Delete all auth-related cookies, passing the server context
  deleteJWTToken(context);
  clearPortalImpersonationCookies({ context });

  for (const cookie of responseHeaders.getSetCookie()) {
    appendResponseHeader('set-cookie', cookie);
  }
});

// Route definition with server-side logout handler
export const Route = createFileRoute('/logout')({
  preload: false,
  beforeLoad: async ({ context }) => {
    context.queryClient.clear();
    await logoutFn();
    throw redirect({ to: '/' });
  },
  component: () => (
    <div>
      <h1>Logging out...</h1>
      <p>You will be redirected shortly.</p>
    </div>
  ),
});
